import React, { useState } from 'react';
import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { HoaDonDieuChinhThongTinInput, PhuongThucThanhToan } from '@/types/schemas';
import { formSchema, FormValues } from '../../schemas';
import ConfirmDialog from './ConfirmDialog';
import BasicInfo from './BasicInfo';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: HoaDonDieuChinhThongTinInput) => void;
}

function FormDialog({ open, onClose, onSubmit }: FormDialogProps) {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [phuongThucThanhToan, setPhuongThucThanhToan] = useState<PhuongThucThanhToan | null>(null);

  const handleSubmit = (data: FormValues) => {
    const formattedData: HoaDonDieuChinhThongTinInput = {
      ...data,
      unit_id: data.unit_id || 0,
      ma_pttt: phuongThucThanhToan?.ma_pttt || ''
    };

    onSubmit(formattedData);
    onClose();
  };

  const handleCloseDialog = () => {
    setShowConfirmDialog(false);
    onClose();
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title='Tạo mới hóa đơn điều chỉnh thông tin'
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={12} />}
      >
        <AritoFormV2
          mode='add'
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={
            <BasicInfo phuongThucThanhToan={phuongThucThanhToan} setPhuongThucThanhToan={setPhuongThucThanhToan} />
          }
          bottomBar={<BottomActionBarV2 mode='add' onClose={onClose} />}
        />
      </DialogV2>

      <ConfirmDialog
        onClose={handleCloseDialog}
        open={showConfirmDialog}
        onCloseConfirmDialog={() => setShowConfirmDialog(false)}
      />
    </>
  );
}

export default FormDialog;
